import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import InlineSVG from 'svg-inline-react';
import { debounce } from 'utils/utils';

import './Modal.scss';

export default class Modal extends Component {
  static propTypes = {
    children: PropTypes.object.isRequired,
    icon: PropTypes.string,
    isMobileBreakpoint: PropTypes.bool,
    modalConfig: PropTypes.object,
    onModalClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isMobileBreakpoint: false,
    modalConfig: {},
  }

  state = {};

  componentDidMount() {
    this.selectDisplayMethod(this.modalContentRef);
    window.addEventListener('resize', this.resizeHandler);
    window.addEventListener('keyup', this.modalCloseWithEscape);
  }

  shouldComponentUpdate = shouldPureComponentUpdate;

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
    window.removeEventListener('keyup', this.modalCloseWithEscape);
  }

  modalClose = (event) => {
    event.preventDefault();
    this.props.onModalClose(event);
  };

  modalCloseWithEscape = (event) => {
    const escapeKeycode = 27;

    if (event.keyCode === escapeKeycode) {
      this.props.onModalClose(event);
    }
  };

  resizeHandler = debounce(() => {
    /* istanbul ignore next */
    this.selectDisplayMethod(this.modalContentRef);
  }, 300);

  saveModalContentRef = ref => this.modalContentRef = ref;

  saveModalRef = ref => this.modalRef = ref;

  get viewportHeight() {
    /* istanbul ignore next */
    return window.innerHeight;
  }

  selectDisplayMethod(modalContentRef) {
    if (this.props.modalConfig.forceFullHeight) {
      this.setState({
        display: 'fullHeight',
      });
    } else {
      const topModalPosition = modalContentRef.getBoundingClientRect().top;
      const modalHeight = modalContentRef.offsetHeight;
      const contentHeight = topModalPosition + modalHeight;
      this.setState({
        display: contentHeight > this.viewportHeight ? 'fullHeight' : 'verticallyCentered',
      });
    }
  }

  render() {
    const {
      children,
      icon,
      isMobileBreakpoint,
      modalConfig,
    } = this.props;

    const modalStyles = {};

    if (!isMobileBreakpoint) {
      modalStyles.width = '600px';
    }

    if (modalConfig.width) {
      modalStyles.width = modalConfig.width;
    }

    const hideCloseButton = modalConfig.hideCloseButton;

    return (
      <section
        className={`modal ${this.state.display === 'fullHeight' ? 'modal--is-full-height' : 'modal--is-vertically-centered'}`}
        style={modalStyles}
        ref={this.saveModalRef}
      >
        <div onClick={hideCloseButton ? '' : this.modalClose} className="modal__screen" />
        <div
          className={`modal__content ${icon && 'modal__content--is-with-icon'}`}
        >
          { !hideCloseButton && (
            <a href="#" onClick={this.modalClose} className="modal__content__close" title="Close" />
          ) }

          <div className="modal__content__inner">
            <div ref={this.saveModalContentRef}>
              { icon && (<InlineSVG className="modal__logo" src={icon} />) }

              {children}
            </div>
          </div>
        </div>
      </section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Modal/Modal.jsx
 **/